import { render, staticRenderFns } from "./disease.vue?vue&type=template&id=17ee383b&scoped=true&"
import script from "./disease.vue?vue&type=script&lang=js&"
export * from "./disease.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17ee383b",
  null
  
)

export default component.exports